import React from 'react'
import { Typography, Icon, Row, Col, Pagination, Collapse, Modal, Button, message } from 'antd'
import { Queries, Mutations } from '../../../graphql'
import { withApollo } from 'react-apollo'
import moment from 'moment'
import Container from '../../../components/user/Container'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import { convertToHTMl } from '../../../utils/markDown'
import { Link } from 'react-router-dom'
const { Text, Title } = Typography

const { Panel } = Collapse;

class Notification extends React.Component {

    state = {
        NEWS: "",
        currentNEWS: 1,
        offsetNEWS: 0,
        limitNEWS: 3,
        totalNEWS:0,
        readNEWS:0,
        limitPagination: 3,
        POLICY: "",
        currentPOLICY: 1,
        offsetPOLICY: 0,
        limitPOLICY: 3,
        totalPOLICY:0,
        readPOLICY:0,
        SCHEME: "",
        currentSCHEME: 1,
        offsetSCHEME: 0,
        limitSCHEME: 3,
        totalSCHEME:0,
        readSCHEME:0,
        SALARY: "",
        currentSALARY: 1,
        offsetSALARY: 0,
        limitSALARY: 3,
        totalSALARY:0,
        readSALARY:0,
        OTHER: "",
        currentOTHER: 1,
        offsetOTHER: 0,
        limitOTHER: 3,
        RELEASE: "",
        currentRELEASE: 1,
        offsetRELEASE: 0,
        limitRELEASE: 3,
        totalRELEASE:0,
        readRELEASE:0,
        WELFARE: "",
        currentWELFARE: 1,
        offsetWELFARE: 0,
        limitWELFARE: 3,
        totalWELFARE:0,
        readWELFARE:0,
        showModaldetail: false,
        datanoti: null,
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        showModalErrors: false,
        showDetailNotiFace:"",
        profileiIsPlasma:null,
        slugShowUrl: false,
        SSO: "",
        currentSSO: 1,
        offsetSSO: 0,
        limitSSO: 3,
        totalSSO:0,
        readSSO:0,
    }

    createUserReadNotification = async (value) => {
        try {
            const { client } = this.props
            const { data, errors } = await client.mutate({
                mutation: Mutations.createUserReadNotification,
                variables: {
                    notificationId: value,
                }
            })
            /////////////////////addmodalINTERNAL_SERVER_ERROR
            if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
                await this.setState({
                    showModalErrors: true
                })
            }
        } catch (error) {
            console.log(error);
            // const errorMessage = error.graphQLErrors[0].message
            // message.error(ErrorMessageFormAPI(errorMessage))
        }
    }

    fetchListNotification = async (Group) => {
        const { client } = this.props
        let offset = ""
        let limit = this.state.limitPagination
        try {
            if (Group == "NEWS"){
                offset = this.state.offsetNEWS
            }else if (Group == "POLICY"){
                offset = this.state.offsetPOLICY
            }else if (Group == "SCHEME"){
                offset = this.state.offsetSCHEME
            }else if (Group == "SALARY"){
                offset = this.state.offsetSALARY
            }else if (Group == "RELEASE"){
                offset = this.state.offsetRELEASE
            }else if (Group == "WELFARE"){
                offset = this.state.offsetWELFARE
            }else if (Group == "SSO"){
                offset = this.state.offsetSSO
            }

            let { data, errors } = await client.query({
                query: Queries.fetchListNotification,
                variables: {
                    notificationGroup: Group,
                    offset,
                    limit
                }
            })
            //////////////////////addmodalINTERNAL_SERVER_ERROR
            if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
                await this.setState({
                    showModalErrors: true
                })
            }

            if(data.fetchListNotification.data[0]) {
                if (Group == "NEWS"){
                    await this.setState({
                        NEWS: [data.fetchListNotification],
                        totalNEWS:data.fetchListNotification.totalNotification,
                        readNEWS:data.fetchListNotification.total,
                    })
                }else if (Group == "POLICY"){
                    await this.setState({
                        POLICY: [data.fetchListNotification],
                        totalPOLICY:data.fetchListNotification.totalNotification,
                        readPOLICY:data.fetchListNotification.total,
                    })
                }else if (Group == "SCHEME"){
                    await this.setState({
                        SCHEME: [data.fetchListNotification],
                        totalSCHEME:data.fetchListNotification.totalNotification,
                        readSCHEME:data.fetchListNotification.total,
                    })
                }else if (Group == "SALARY"){
                    await this.setState({
                        SALARY: [data.fetchListNotification],
                        totalSALARY:data.fetchListNotification.totalNotification,
                        readSALARY:data.fetchListNotification.total,
                    })
                }else if (Group == "RELEASE"){
                    await this.setState({
                        RELEASE: [data.fetchListNotification],
                        totalRELEASE:data.fetchListNotification.totalNotification,
                        readRELEASE:data.fetchListNotification.total,
                    })
                }else if (Group == "WELFARE"){
                    await this.setState({
                        WELFARE: [data.fetchListNotification],
                        totalWELFARE:data.fetchListNotification.totalNotification,
                        readWELFARE:data.fetchListNotification.total,
                    })
                }else if (Group == "SSO"){
                    await this.setState({
                        SSO: [data.fetchListNotification],
                        totalSSO:data.fetchListNotification.totalNotification,
                        readSSO:data.fetchListNotification.total,
                    })
                }
            }
        } catch (error) {
            console.log('error', error)
        }
    }

    createUserResultNotification = async (value) => {
        try {
            const { client } = this.props
            const { data, errors } = await client.mutate({
                mutation: Mutations.createUserResultNotification,
                variables: {
                    notificationId: value,
                }
            })
            /////////////////////addmodalINTERNAL_SERVER_ERROR
            if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
                await this.setState({
                    showModalErrors: true
                })
            }
            message.success("รับทราบเรียบร้อย")
        } catch (error) {
            // console.log(error);
            // const errorMessage = error.graphQLErrors[0].message
            // message.error(ErrorMessageFormAPI(errorMessage))
        }
    }

    handleOk = async (value) => {
        await this.setState({
            showModaldetail: false,
        });
        await this.createUserResultNotification(value.notificationId);
        await this.allfetch();
    };

    handleCancel = async e => {
        // console.log(e);
        await this.setState({
            showModaldetail: false,
            showDetailNotiFace:""
        });

        await this.fetchCountAllNotification();
        await this.allfetch();
        
    };

    showModalnoti = async (value, showLink, slug) => {
       console.log("value", value)
       console.log("value showLink", showLink)
       console.log("value slug", slug)

      // if(slug === "SSO"){
      //    window.location.href = '/profile/SecuritySettings'
      // }else{
         if(value.redirectPath?.includes('Leave/Confirm/')){
            let cutStringId = value.redirectPath.split('/');
            value.redirectPath = 'Leave/Confirm/noti/'+cutStringId[2]
         }
           value.showLink = showLink
           await this.setState({
               showModaldetail: true,
               datanoti: value,
               slugShowUrl: slug
           });
   
            console.log('showLink', value) 
   
           await this.createUserReadNotification(value.notificationId);
      // }
    }

    renderBox = (dataNotification, showLink, slug = false) => {
      
        if (dataNotification) {
            return (
                dataNotification = dataNotification[0].data.map(dataNoti => (
                    <a onClick={e => this.showModalnoti(dataNoti, showLink, slug)}>
                        <div style={dataNoti.read == 1 ? { width: "100%", padding: "15px", backgroundColor: "#DFDFDF" } : { width: "100%", padding: "15px", backgroundColor: "white" }}>
                            <Row>
                                <Col xs={1} sm={1} md={1} >
                                    <Icon type="mail" style={{ color: "white", fontSize: "20px" }} theme="filled" className="custom-icons-border1" />
                                </Col>
                                <Col xs={24} sm={24} md={21} >
                                    {dataNoti.read == 1 &&
                                        <div className=" ml-4" >
                                            <Text style={{ fontFamily: 'none', fontSize: '15px' }} >{dataNoti.title}<br /></Text>
                                        </div>
                                        ||
                                        <div className=" ml-4" >
                                            <Text style={{ fontSize: '15px' }} >{dataNoti.title}<br /></Text>
                                        </div>
                                    }
                                    <div className=" ml-4 mb-2" >
                                        <Text style={{ fontSize: '10px' }} >
                                            {/* <div dangerouslySetInnerHTML={{ __html: convertToHTMl(dataNoti.body) }}/> */}
                                            <div className="custom-text-markdown" dangerouslySetInnerHTML={{ __html: convertToHTMl(dataNoti.body) }}/>
                                        </Text>
                                    </div>
                                    {
                                        dataNoti.division &&
                                        <div className="ml-4">
                                            <Text style={{ fontSize: '10px' }}>{ dataNoti.division }</Text>
                                        </div>
                                    }
                                    <Text className=" ml-4" style={{ fontSize: '10px', color: '#f1b341' }} >{moment(dataNoti.createdAt).fromNow()}</Text>
                                </Col>
                                <Col xs={1} sm={1} md={1} >
                                    {dataNoti.isConfirm == 1 &&
                                        <>
                                            {dataNoti.confirm == 0 &&
                                                <>
                                                    <Icon type="bell" style={{ color: "white", fontSize: "15px" }} className="custom-icons-border2" />
                                                </>
                                            }
                                        </>
                                    }
                                    {/* dataNoti.isConfirm : {dataNoti.isConfirm} dataNoti.confirm : {dataNoti.confirm} */}
                                </Col>
                            </Row>
                        </div>
                    </a >
                    // </>
                )))
        }
    }

    renderNoData = () =>{
        return(
            <>
                <div style={{ textAlign: 'center', borderRadius: "10px", height: "60px", backgroundColor: "white" }}>
                    <div style={{ padding: "20px" }}>
                        <Text className="color-gray" style={{ fontSize: '17px' }} >ไม่พบข้อมูล</Text>
                    </div>
                </div>
            </>
        )
    }

    allfetch = async () => {
        await this.fetchListNotification("NEWS")
        await this.fetchListNotification("POLICY")
        await this.fetchListNotification("SCHEME")
        await this.fetchListNotification("SALARY")
        await this.fetchListNotification("RELEASE")
        await this.fetchListNotification("WELFARE")
        await this.fetchListNotification("SSO")
        // await this.fetchListNotification("OTHER")
    }

    onChangePagination = async (page, slug) =>{
        // console.log(page, slug)
        const { limitPagination } = this.state
        let newoffset = limitPagination * (page - 1)
        if(slug == "NEWS"){
            await this.setState({
                currentNEWS: page,
                offsetNEWS: newoffset,
            });
        }else if(slug == "POLICY"){
            await this.setState({
                currentPOLICY: page,
                offsetPOLICY: newoffset,
            });
        }else if(slug == "SCHEME"){
            await this.setState({
                currentSCHEME: page,
                offsetSCHEME: newoffset,
            });
        }else if(slug == "SALARY"){
            await this.setState({
                currentSALARY: page,
                offsetSALARY: newoffset,
            });
        }else if(slug == "OTHER"){
            await this.setState({
                currentOTHER: page,
                offsetOTHER: newoffset,
            });
        }else if(slug == "WELFARE"){
            await this.setState({
                currentWELFARE: page,
                offsetWELFARE: newoffset,
            });
        }else if(slug == "SSO"){
            await this.setState({
                currentSSO: page,
                offsetSSO: newoffset,
            });
        }
       
        this.fetchListNotification(slug)
    }

    onChangeNEWS = async page => {
        const { limitNEWS } = this.state
        let newoffset = limitNEWS * (page - 1)
        await this.setState({
            currentNEWS: page,
            offsetNEWS: newoffset,
        });
        this.fetchListNotification("NEWS")
    };

    onChangePOLICY = async page => {
        const { limitPOLICY } = this.state
        let newoffset = limitPOLICY * (page - 1)
        await this.setState({
            currentPOLICY: page,
            offsetPOLICY: newoffset,
        });
        this.fetchListNotification("POLICY")
    };

    onChangeSCHEME = async page => {
        const { limitSCHEME } = this.state
        let newoffset = limitSCHEME * (page - 1)
        await this.setState({
            currentSCHEME: page,
            offsetSCHEME: newoffset,
        });
        this.fetchListNotification("SCHEME")
    };

    onChangeSALARY = async page => {
        const { limitSALARY } = this.state
        let newoffset = limitSALARY * (page - 1)
        await this.setState({
            currentSALARY: page,
            offsetSALARY: newoffset,
        });
        this.fetchListNotification("SALARY")
    };

    onChangeSSO = async page => {
        const { limitSSO } = this.state
        let newoffset = limitSSO * (page - 1)
        await this.setState({
            currentSSO: page,
            offsetSSO: newoffset,
        });
        this.fetchListNotification("SSO")
    };

    onChangeOTHER = async page => {
        const { limitOTHER } = this.state
        let newoffset = limitOTHER * (page - 1)
        await this.setState({
            currentOTHER: page,
            offsetOTHER: newoffset,
        });
        this.fetchListNotification("OTHER")
    };

    fetchData = async (slug, dataId) =>{
        const { client } = this.props
        
        // console.log(slug)
        try {
            if (slug == "NEWS") {
                let { data, errors } = await client.query({
                    query: Queries.fetchListPost,
                    variables: {
                        postId: dataId,
                    }
                })
                //////////////////////addmodalINTERNAL_SERVER_ERROR
                if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
                    await this.setState({
                        showModalErrors: true
                    })
                }
                if (data.fetchListPost.data[0]) {
                    // await this.setState({
                    //     showDetailNotiFace: data.fetchListPost.data[0].descriptionTH
                    // })
                    window.open('/news/detailnews/'+data.fetchListPost.data[0].postId, '_blank');
                }
            }
            else if (slug == "POLICY") {
                let { data, errors } = await client.query({
                    query: Queries.fetchListDocumen,
                    variables: {
                        docId: dataId,
                    }
                })
                //////////////////////addmodalINTERNAL_SERVER_ERROR
                if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
                    await this.setState({
                        showModalErrors: true
                    })
                }
                if (data.fetchListDocument[0]) {
                    // await this.setState({
                    //     showDetailNotiFace: data.fetchListDocument[0].docDescription
                    // })
                    window.open('/policy/detail/'+data.fetchListDocument[0].docId, '_blank');
                }
            }
            else if (slug == "SCHEME") {
                let { data, errors } = await client.query({
                    query: Queries.fetchNotification,
                    variables: {
                        notificationId: dataId,
                    }
                })

                if(data.fetchNotification.notiFrom == 'VTRC'){
                    window.open('/course/WORK/'+data.fetchNotification.courseId, '_blank');
                }else{
                    window.open('/course/CONICLE/'+dataId, '_blank');
                }
            }else if(slug == "WELFARE"){
                let { data, errors } = await client.query({
                    query: Queries.fetchNotification,
                    variables: {
                        notificationId: dataId,
                    }
                })

                if(data.fetchNotification){
                    if(data.fetchNotification.redirectPath.includes('hospital')){
                        let wdHospitalId = data.fetchNotification.redirectPath.split('/');
                        if(data.fetchNotification.redirectPath.includes('Withdraw')){
                            await this.redirectWDHospitalPath(wdHospitalId[3], 'WDHOSPITAL', data.fetchNotification.redirectPath)
                        }else{
                            await this.redirectWDHospitalPath(wdHospitalId[3], 'CONFIRM', data.fetchNotification.redirectPath)
                        }
                    }else if(data.fetchNotification.redirectPath.includes('Leave')){
                        if(data.fetchNotification.redirectPath.includes('Leave/Confirm/')){
                           let cutStringId = data.fetchNotification.redirectPath.split('/');
                           let newsLink = 'Leave/Confirm/noti/'+cutStringId[2]
                           window.open(newsLink, '_blank');
                        }else{
                           window.open(data.fetchNotification.redirectPath, '_blank');
                        }
                    }else if(data.fetchNotification.redirectPath.includes('APPROVEABSTAINTIME')){
                       let cutStringId = data.fetchNotification.redirectPath.split('/');
                        if(data.fetchNotification.redirectPath.includes('APPROVEABSTAINTIME/APPROVE/APPROVERID')){
                           let newsLink = 'AbstainTime/Confirm/'+cutStringId[4]
                           window.open(newsLink, '_blank');
                        }else{
                           let newsLink = 'AbstainTime/Form/edit/'+cutStringId[4]
                           window.open(newsLink, '_blank');
                        // window.open(data.fetchNotification.redirectPath, '_blank');
                        }
                     // APPROVEABSTAINTIME/APPROVE/APPROVERID/
                    }
                    else if(data.fetchNotification.redirectPath.includes('studyPayment')){
                        const params = new URLSearchParams({
                          isApproveMode: true,
                        }).toString();
                           window.open(`${data.fetchNotification.redirectPath}?${params}`, '_blank');
                        }
                }
            }

        } catch (error) {
            console.log('error', error)
        }
    }

    redirectWDHospitalPath = async (wdHospitalId, type, linkOpen) =>{
        const { client } = this.props
        let { data, errors } = await client.query({
            query: Queries.redirectWDHospitalPath,
            variables: {
                wdHospitalId,
                type
            }
        })

        if(type == 'WDHOSPITAL'){
            window.open(linkOpen, '_blank');
        }else{
            let newsLink = linkOpen+'/'+data.redirectWDHospitalPath.status
            window.open(newsLink, '_blank');
        }
    }
    
    onClickShowDetailNoti = async value =>{
        const { slugShowUrl } = this.state

        if(slugShowUrl  == 'NEWS'){
            await this.fetchData("NEWS", value.postId)
        }else if(slugShowUrl == 'POLICY'){
            await this.fetchData("POLICY", value.docId)
        }else if(slugShowUrl == 'SCHEME'){
            await this.fetchData("SCHEME", value.notificationId)
        }else if(slugShowUrl == 'WELFARE'){
            await this.fetchData("WELFARE", value.notificationId)
        }
    }

    fetchCountAllNotification = async () =>{
		const { client } = this.props
		const { data } = await client.query({
			query: Queries.fetchCountAllNotification,
		})

		sessionStorage.setItem('notiCouts', parseInt(data.fetchCountAllNotification));
        let text = data.fetchCountAllNotification.toString();;
        let countNotMyArray  = text.split("");

        if(parseInt(document.getElementById('test-value'))){
            if(parseInt(document.getElementById('test-value').getElementsByClassName('ant-scroll-number ant-badge-count ant-badge-multiple-words')[0].getAttribute('title')) >= 100){
                document.getElementById('test-value').getElementsByClassName('ant-scroll-number ant-badge-count ant-badge-multiple-words')[0].innerHTML = parseInt(data.fetchCountAllNotification);
            }
        }else{
            if(countNotMyArray[0]){
                if(document.getElementById('test-value')?.getElementsByClassName('ant-scroll-number-only-unit current')[0]){
                    document.getElementById('test-value').getElementsByClassName('ant-scroll-number-only-unit current')[0].innerHTML = countNotMyArray[0];
                }
            }else{
                if(document.getElementById('test-value')?.getElementsByClassName('ant-scroll-number-only-unit current')[0]){
                    document.getElementById('test-value').getElementsByClassName('ant-scroll-number-only')[0].innerHTML = ''
                }
            }
            
            if(countNotMyArray[1]){
                if(document.getElementById('test-value')?.getElementsByClassName('ant-scroll-number-only-unit current')[1]){
                    document.getElementById('test-value').getElementsByClassName('ant-scroll-number-only-unit current')[1].innerHTML = countNotMyArray[1];
                }
            }else{
                if(document.getElementById('test-value')?.getElementsByClassName('ant-scroll-number-only-unit current')[1]){
                    document.getElementById('test-value').getElementsByClassName('ant-scroll-number-only')[1].innerHTML = ''
                }
            }
            
            if(countNotMyArray[2]){
                if(document.getElementById('test-value')?.getElementsByClassName('ant-scroll-number-only-unit current')[2]){
                    document.getElementById('test-value').getElementsByClassName('ant-scroll-number-only-unit current')[2].innerHTML = countNotMyArray[2];
                }
            }else{
                if(document.getElementById('test-value')?.getElementsByClassName('ant-scroll-number-only-unit current')[2]){
                    document.getElementById('test-value').getElementsByClassName('ant-scroll-number-only')[2].innerHTML = ''
                }
            }
        }
		await this.setState({
			totalNotfiction: data.fetchCountAllNotification
		})
	}


    fetchProfile = async () => {
		try {
			const { client } = this.props
			const { data } = await client.query({
				query: Queries.fetchProfile
			})

			if(data.fetchProfile){
				await this.setState({ 
					profileiIsPlasma: data.fetchProfile.isPlasma,
				})

			}else{
				// return null
			}
			
		} catch (e) {
			// message.error('Something went wrong. Please try again')
		}
	}

    componentDidMount = async () => {
        await this.allfetch()
        await this.fetchProfile()
        // console.log('asdfasdf',document.getElementById('test-value').getElementsByClassName('ant-scroll-number-only-unit current')[1])
    }

    render() {
        const { match } = this.props
        const { datanoti, 
                NEWS, 
                currentNEWS, 
                limitNEWS, 
                currentPOLICY, 
                limitPOLICY, 
                currentSCHEME, 
                limitSCHEME, 
                currentSALARY, 
                limitSALARY, 
                currentOTHER, 
                limitOTHER, 
                POLICY, 
                SCHEME, 
                SALARY, 
                OTHER, 
                showDetailNotiFace,
                totalNEWS,
                readNEWS,
                totalPOLICY,
                readPOLICY,
                totalSCHEME,
                readSCHEME,
                totalSALARY,
                readSALARY,
                RELEASE,
                currentRELEASE,
                offsetRELEASE,
                limitRELEASE,
                totalRELEASE,
                readRELEASE,
                WELFARE,
                currentWELFARE,
                offsetWELFARE,
                limitWELFARE,
                totalWELFARE,
                readWELFARE,
                profileiIsPlasma,
                SSO,
                readSSO,
                totalSSO,
                currentSSO,
                limitSSO,
                slugShowUrl
        } = this.state
        return (
            <Container match={match}>
                {datanoti &&
                    <Modal
                        destroyOnClose={true}
                        maskClosable={false}
                        title={datanoti.title}
                        visible={this.state.showModaldetail}
						      className="modal-noti"
                        // mask={false}
                        onCancel={this.handleCancel}
                        footer={
                            datanoti.confirm == 0 &&
                            [
                                <Button key="submit" style={{}} type="primary btn-color-transparent btn-custom" onClick={e => this.handleOk(datanoti)}>
                                    รับทราบ
                                </Button>
                            ]
                            ||
                            datanoti.confirm == 1 &&
                            [
                                <Button key="submit" disabled={true} style={{}} type="primary color-white btn-custom ">
                                    รับทราบแล้ว</Button>
                            ]
                        }
                    >
                        <div className="mb-3">
                            <div dangerouslySetInnerHTML={{ __html: convertToHTMl(datanoti.body) }}/>
                        </div>
                        {
                            datanoti.showLink &&
                                ( datanoti.postId || datanoti.docId || datanoti.notificationId) &&
                                <p className="color-orange" onClick={e => this.onClickShowDetailNoti(datanoti)} style={{ cursor:"pointer" }}>
                                    รายละเอียดเพิ่มเติม
                                </p>
                        }
                        
                        {
                           this.state.slugShowUrl === "SSO" &&
                              <Link
                                 to={{
                                       pathname: '/profile/SecuritySettings',
                                 }}
                                 className="color-orange"
                              >
                                    ตรวจสอบ
                              </Link>
                           }

                        {/* {
                           slugShowUrl === "SSO" &&
                           <p className="color-orange" style={{ cursor:"pointer" }}>
                              รายละเอียดเพิ่มเติม
                           </p>
                        } */}
                        
                        {/* {
                            showDetailNotiFace &&

                            <div dangerouslySetInnerHTML={{ __html: convertToHTMl(showDetailNotiFace) }} />
                            
                        } */}
                    </Modal>
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                    <>
                        <Row gutter={16} className="mb-3" type="flex" align="top" >
                            <Col xs={{ span: 24 }} lg={{ span: 11 }} className="mb-3">
                                <div >
                                    <Text>ข่าวสาร มีจำนวนที่ยังไม่ได้อ่าน ({readNEWS}) จากทั้งหมด ({totalNEWS})</Text>
                                    <hr className="pb-1"/>
                                    {
                                        NEWS[0] &&
                                        <>
                                            {this.renderBox(NEWS, "showLink", "NEWS")}
                                            <Pagination className={'paginationred'} defaultCurrent={1} onChange={e => this.onChangePagination(e, "NEWS")} total={NEWS[0].totalNotification} pageSize={limitNEWS} />
                                        </>
                                        ||
                                        this.renderNoData()
                                    }
                                </div>
                            </Col>
                            {
                                profileiIsPlasma && profileiIsPlasma !== 1 ?(
                                    <>
                                        <Col xs={{ span: 24 }} lg={{ span: 11 }} className="mb-3">
                                            <div>
                                                <Text>ระเบียบ/หลักเกณฑ์ มีจำนวนที่ยังไม่ได้อ่าน ({readPOLICY}) จากทั้งหมด ({totalPOLICY})</Text>
                                                <hr className="pb-1"/>
                                                {
                                                    POLICY[0] &&
                                                    <>
                                                        {this.renderBox(POLICY, "showLink", "POLICY")}
                                                        <Pagination className={'paginationred'} defaultCurrent={1} current={currentPOLICY} total={10} onChange={e => this.onChangePagination(e, "POLICY")} total={POLICY[0].totalNotification} pageSize={limitPOLICY} />
                                                    </>
                                                    ||
                                                    this.renderNoData()
                                                }
                                            </div>
                                        </Col>
                                    </>
                                
                                ): <div></div>
                            }
                            <Col xs={{ span: 24 }} lg={{ span: 11 }} className="mb-3">
                                <div>
                                    <Text>หลักสูตร มีจำนวนที่ยังไม่ได้อ่าน ({readSCHEME}) จากทั้งหมด ({totalSCHEME})</Text>
                                    <hr className="pb-1"/>
                                    {
                                        SCHEME[0] &&
                                        <>
                                            {this.renderBox(SCHEME, "showLink", "SCHEME")}
                                            <Pagination className={'paginationred'} defaultCurrent={1} current={currentSCHEME} total={10} onChange={e => this.onChangePagination(e, "SCHEME")} total={SCHEME[0].totalNotification} pageSize={limitSCHEME} />
                                        </>
                                        ||
                                        this.renderNoData()
                                    }
                                </div>
                            </Col>
                            {
                                WELFARE[0] &&
                                <Col xs={{ span: 24 }} lg={{ span: 11}} className="mb-3">
                                    <div>
                                        <Text>สวัสดิการ มีจำนวนที่ยังไม่ได้อ่าน ({readWELFARE}) จากทั้งหมด ({totalWELFARE})</Text>
                                        <hr className="pb-1"/>
                                        {
                                            WELFARE[0] &&
                                            <>
                                                {this.renderBox(WELFARE, "showLink", "WELFARE")}
                                                <Pagination className={'paginationred'} defaultCurrent={1} current={currentWELFARE} total={10} onChange={e => this.onChangePagination(e, "WELFARE")} total={WELFARE[0].totalNotification} pageSize={limitRELEASE} />
                                            </>
                                            ||
                                            this.renderNoData()
                                        }
                                    </div>
                                </Col>
                            }
                            {
                                RELEASE[0] &&
                                <Col xs={{ span: 24 }} lg={{ span: 11}} className="mb-3">
                                    <div>
                                        <Text>อัปเดตแอปพลิเคชัน มีจำนวนที่ยังไม่ได้อ่าน ({readRELEASE}) จากทั้งหมด ({totalRELEASE})</Text>
                                        <hr className="pb-1"/>
                                        {
                                            RELEASE[0] &&
                                            <>
                                                {this.renderBox(RELEASE,"")}
                                                <Pagination className={'paginationred'} defaultCurrent={1} current={currentRELEASE} total={10} onChange={e => this.onChangePagination(e, "RELEASE")} total={RELEASE[0].totalNotification} pageSize={limitRELEASE} />
                                            </>
                                            ||
                                            this.renderNoData()
                                        }
                                    </div>
                                </Col>
                            }
                            
                            {
                                SALARY[0] &&
                                <Col xs={{ span: 24 }} lg={{ span: 11 }} className="mb-3">
                                    <div>
                                        <Text>เงินเดือน มีจำนวนที่ยังไม่ได้อ่าน ({readSALARY}) จากทั้งหมด ({totalSALARY})</Text>
                                        <hr className="pb-1"/>
                                        {
                                            SALARY[0] &&
                                            <>
                                                {this.renderBox(SALARY)}
                                                <Pagination className={'paginationred'} defaultCurrent={1} current={currentSALARY} total={10} onChange={e => this.onChangePagination(e, "SALARY")} total={SALARY[0].totalNotification} pageSize={limitSALARY} />
                                            </>
                                            ||
                                            this.renderNoData()
                                        }
                                    </div>
                                </Col>
                            }
                            
                            {
                                SSO[0] &&
                                <Col xs={{ span: 24 }} lg={{ span: 11 }} className="mb-3">
                                    <div>
                                        <Text>การเปลี่ยนแปลงสิทธิ์การเข้าใช้งาน ({readSSO}) จากทั้งหมด ({totalSSO})</Text>
                                        <hr className="pb-1"/>
                                        {
                                            SSO[0] &&
                                            <>
                                                {this.renderBox(SSO, "", "SSO")}
                                                <Pagination className={'paginationred'} defaultCurrent={1} current={currentSSO} total={10} onChange={e => this.onChangePagination(e, "SSO")} total={SSO[0].totalNotification} pageSize={limitSSO} />
                                            </>
                                            ||
                                            this.renderNoData()
                                        }
                                    </div>
                                </Col>
                            }
                            
                        </Row>
                        <Row gutter={16} className="mb-3">
                            {/* {
                                SALARY[0] &&
                                <Col xs={{ span: 24 }} lg={{ span: 11 }} className="mb-3">
                                    <div>
                                        <Text>เงินเดือน มีจำนวนที่ยังไม่ได้อ่าน ({readSALARY}) จากทั้งหมด ({totalSALARY})</Text>
                                        <hr className="pb-1"/>
                                        {
                                            SALARY[0] &&
                                            <>
                                                {this.renderBox(SALARY)}
                                                <Pagination className={'paginationred'} defaultCurrent={1} current={currentSALARY} total={10} onChange={e => this.onChangePagination(e, "SALARY")} total={SALARY[0].totalNotification} pageSize={limitSALARY} />
                                            </>
                                            ||
                                            this.renderNoData()
                                        }
                                    </div>
                                </Col>
                            }

{
                                SSO[0] &&
                                <Col xs={{ span: 24 }} lg={{ span: 11 }} className="mb-3">
                                    <div>
                                        <Text>SSO มีจำนวนที่ยังไม่ได้อ่าน ({readSSO}) จากทั้งหมด ({totalSSO})</Text>
                                        <hr className="pb-1"/>
                                        {
                                            SSO[0] &&
                                            <>
                                                {this.renderBox(SSO)}
                                                <Pagination className={'paginationred'} defaultCurrent={1} current={currentSSO} total={10} onChange={e => this.onChangePagination(e, "SSO")} total={SSO[0].totalNotification} pageSize={limitSSO} />
                                            </>
                                            ||
                                            this.renderNoData()
                                        }
                                    </div>
                                </Col>
                            } */}

                        </Row>
                    </>
            </Container>
        )
    }
}

Notification.propTypes = {
    //
}

export default withApollo(Notification)